import React, { useRef, useState } from "react"
import { useTracking } from "react-tracking"
import { Card } from "../../components/card"
import { InputText } from "../../components/input-text/input-text"
import { useFormik } from "formik"
import { formikConfig } from "../../modules/formik/config"
import { CardFooter } from "../../components/card-footer"
import { ConversationBubble } from "../../components/conversation-bubble"
import { encodeBase64 } from "../../modules/functions"
import { PrivacyText } from "../../components/privacy"
import { Root } from "../../components/root"

import "./style.scss"

const App = () => {
    const [isLoading, setIsLoading] = useState(false)

    const sgnRef = useRef() as React.MutableRefObject<HTMLDivElement>
    const { trackEvent } = useTracking()
    const formik = useFormik({
        ...formikConfig,
        initialValues: { ...formikConfig.initialValues, location: "web", source: "signup" },
    })

    function trackedSubmitForm() {
        setIsLoading(true)
        trackEvent({
            event: "genericEvent",
            category: "click",
            action: "click button",
            label: "signup",
        })

        formik.submitForm().then((data) => {
            // we check if it is undefined because that means the validation has failed
            if (data !== undefined) {
                trackEvent({
                    event: "genericEvent",
                    category: "submit",
                    action: "submit button",
                    label: "signup",
                })
                const isCompatible = data === "compatible"
                const values = { ...formik.values, mx: undefined, location: undefined, source: undefined }
                if (isCompatible) {
                    window.location.href = `/choose-plan?bpm_fd=${encodeBase64(JSON.stringify(values))}`
                } else {
                    window.location.href = `https://blackpearlmail.com/incompatible-email-hosting-provider/?bpm_fd=${encodeBase64(
                        JSON.stringify(values)
                    )}`
                }
            } else {
                setIsLoading(false)
            }
        })
    }

    return (
        <Root id="sgn" ref={sgnRef}>
            <Card>
                <ConversationBubble
                    header="Hi, I'm Eden. I'll be helping set up your account today."
                    para="Let's get started with a few important details."
                />
                <InputText
                    id="name"
                    className="form-item"
                    label="Full name"
                    error={formik.errors.name as string}
                    placeholder="Your full name"
                    maxLength={100}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
                <InputText
                    id="orgname"
                    className="form-item"
                    label="Business name"
                    error={formik.errors.orgname as string}
                    placeholder="Your business name"
                    maxLength={100}
                    value={formik.values.orgname}
                    onChange={formik.handleChange}
                />
                <InputText
                    id="email"
                    className="form-item"
                    label="Business email"
                    error={formik.errors.email as string}
                    placeholder="Your business email address"
                    maxLength={100}
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    autoCapitalize="none"
                />
                <InputText
                    id="workphone"
                    className="form-item"
                    label="Business phone"
                    error={formik.errors.workphone as string}
                    placeholder="Your business phone number"
                    maxLength={30}
                    type={"tel"}
                    value={formik.values.workphone}
                    onChange={formik.handleChange}
                />
                <CardFooter
                    className="sgn-next"
                    nextAction={trackedSubmitForm}
                    disabled={isLoading}
                    currentCount={1}
                    maxCount={3}
                />
                <PrivacyText />
            </Card>
        </Root>
    )
}

export default App
